<template>
  <div>
    <v-toolbar middle dark>
      <v-img
        v-if="$store.state.session.Logo"
        max-height="50"
        max-width="50"
        :src="$store.state.session.Logo" />
      <!--img :src="$store.state.session.Logo" height="45" width="100" /-->
      <v-toolbar-title
        v-if="$store.state.session.Nombre"
        class="margin-left"
        @click="to('/')"
        v-text="`   ${$store.state.session.Nombre}`">
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-chip
        class="ma-2"
        color="green"
        text-color="white">
        <v-avatar
          left
          class="green darken-4"
          v-text="$store.getters.pendingOrders"></v-avatar>
        Órdenes Nuevas
      </v-chip>
      <v-btn icon @click="signOut()">
        <v-icon>mdi-export</v-icon>
      </v-btn>
    </v-toolbar>
    <div>
      <v-container fluid>
        <v-row no-gutters>
          <v-col cols="2">
            <v-tabs
              middle
              vertical
              icons-and-text
              dark>
              <v-tab to="/">
                Órdenes
                <v-icon x-large>mdi-ticket</v-icon>
              </v-tab>
              <v-tab to="/delivery">
                Domicilio
                <v-icon x-large>mdi-car-outline</v-icon>
              </v-tab>
              <v-tab to="/pickup">
                Pickup
                <v-icon x-large>mdi-store-outline</v-icon>
              </v-tab>
              <v-tab to="/history">
                Historial
                <v-icon x-large>mdi-history</v-icon>
              </v-tab>
              <v-tab to="/canceled">
                Canceladas
                <v-icon x-large>mdi-close-circle-outline</v-icon>
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="10">
            <router-view></router-view>
          </v-col>
        </v-row>
        <v-dialog
          v-model="showNewOrdersModal"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition">
          <v-card color="green">
            <v-card-text class="full-height" align="center" @click="hideNewOrders()">
              <v-container fluid>
                <v-row no-gutters>
                  <v-col class="no-padding">
                    <v-avatar
                      class="green darken-4 norders-label"
                      text-color="white"
                      v-text="$store.getters.pendingOrders">
                    </v-avatar>
                    <p class="norders-title" text-color="white" v-text="$store.getters.pendingOrders > 1 ? 'Nuevas Órdenes' : 'Nueva Orden'"></p>
                    <p class="norders-text">Click para aceptar</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
  </div>
</template>

<script>
  import { fdatabase } from '../plugins/firebase';
  import mixins from '../helpers/mixins';

  export default {
    name: 'Dashboard',
    mixins: [mixins],
    data: () => ({
      notificationAudio: null,
    }),
    computed: {
      showNewOrdersModal() {
        if (this.$store.getters.pendingOrders > 0 && this.notificationAudio != null) {
          this.notificationAudio.play();

          if (this.$route.name == 'index') {
            this.notificationAudio.addEventListener(
              'ended',
              this.repeatNotificationAudio
            );

            return true;
          }
        }

        return false;
      }
    },
    watch: {},
    mounted() {
      this.notificationAudio = new Audio(require('../assets/new-order-alert.mp3'));
      this.setListeners();
    },
    methods: {
      setListeners() {
        const session = this.$store.state.session;

        if (!this.$store.state.orders.addedListener &&
            !this.$store.state.orders.changedListener &&
            !this.$store.state.orders.removedListener &&
            !this.$store.state.onValueListener) {
          this
            .$store
            .state
            .orders
            .addedListener = fdatabase
              .ref(`Restaurantes/${session.storeId}/Sucursales/${session.storePickUpCode}/Ordenes`)
              .on('child_added', (snapshot) => {
                const order = snapshot.val();
                order.realtimeId = snapshot.key;
                if (order.Status == this.$store.state.status[0]) {
                  // if (!this.isForDownload(order.Id)) { // ****
                  if (!this.$store.getters.noOrders && !this.isForDownload(order.Id)) {
                    this.$store
                      .dispatch('addNewOrder', {
                        id: order.Id,
                        order
                      });
                  }
                }
                
                this.$store
                  .dispatch('setRealtimeOrderStatus', {
                    id: order.Id,
                    order
                  });
              });

          this
            .$store
            .state
            .orders
            .changedListener = fdatabase
              .ref(`Restaurantes/${session.storeId}/Sucursales/${session.storePickUpCode}/Ordenes`)
              .on('child_changed', (snapshot) => {
                const order = snapshot.val();
                order.realtimeId = snapshot.key;
                if (!this.$store.getters.noOrders) {
                  const orders = [ order.Id ];

                  if (this.isForDownload(order.Id)) {
                    this.downloadOrders(orders, false);
                  } else {
                    const nStatusIndex = this.$store.state.status.indexOf(order.Status);

                    if (nStatusIndex > -1) {
                      const bIndex = (nStatusIndex > 0) ? nStatusIndex - 1 : nStatusIndex;
                      const from = this.$store.state.status[bIndex];
                      const currentOrder = this.$store.state.orders[from][order.Id];

                      if (currentOrder && currentOrder.downloaded) {
                        this.$store
                          .dispatch('updateOrder', {
                            id: order.Id,
                            status: order.Status
                          });
                      } else {
                        this.downloadOrders(orders, false);
                      }
                    }
                  }
                }

                this.$store
                  .dispatch('setRealtimeOrderStatus', {
                    id: order.Id,
                    order
                  });
              });

          this
            .$store
            .state
            .orders
            .removedListener = fdatabase
              .ref(`Restaurantes/${session.storeId}/Sucursales/${session.storePickUpCode}/Ordenes`)
              .on('child_removed', (snapshot) => {
                const order = snapshot.val();
                this.$store
                  .dispatch('removeOrder', {
                    id: order.Id,
                    status: order.Status
                  });
              });

          this
            .$store
            .state
            .onValueListener = fdatabase
              .ref(`Restaurantes/${session.storeId}/Informacion`)
              .on('value', (snapshot) => {
                const info = snapshot.val();
                this.$store
                  .dispatch('addToSession', info);
              });
        }
      },
      hideNewOrders() {
        const orders = Object.keys(this.$store.state.orders[this.$store.state.status[0]]);

        this.$swal.fire({
            title: 'Aceptando Órdenes',
            html: 'Espere...',
            allowOutsideClick: false,
            onBeforeOpen: () => {
              this.$swal.showLoading();
              
              this.downloadOrders(orders);
            }
          });

        this.notificationAudio.removeEventListener(
          'ended',
          this.repeatNotificationAudio
        );
      },
      signOut() {
        this.$swal
          .fire({
            title: '¿Está seguro?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si',
            cancelButtonText: 'Cancelar'
          })
          .then((result) => {
            if (result.value) {
              this.sendTokenCall('leave', this.$store.state.session.token)
                .then(() => {
                  this.$store.dispatch('signOut').then(() => {
                    this.$router.replace({
                      path: '/login'
                    });
                  });
                })
                .catch(() => {
                  this.$store.dispatch('signOut').then(() => {
                    this.$router.replace({
                      path: '/login'
                    });
                  });
                });
            }
          });
      },
      repeatNotificationAudio() {
        this.notificationAudio.currentTime = 0;
        this.notificationAudio.play();
      },
      to(path) {
        this.$router.push(path);
      },
      isForDownload(orderId) {
        if (this.$store.getters.pendingOrders > 0 && this.$store.state.status.length > 0) {
          return (this.$store.state.orders[this.$store.state.status[0]][orderId] !== undefined);
        }

        return false;
      },
      downloadOrders(orders, updateFirebase = true) {
        this.downloadOrdersCall(orders)
          .then((result) => {
            if (result.code == 200) {
              this.handleOrdersResponse(orders, result.result, true, updateFirebase);
            } else {
              this.handleOrdersResponse(orders, [], false, updateFirebase);
            }
          })
          .catch(() => {
            this.handleOrdersResponse(orders, [], false, updateFirebase);
          });
      },
      handleOrdersResponse(orders, responseOrders, isSuccess, updateFirebase) {
        orders.map((orderId) => {
          if (isSuccess) {
            const arrayExists = responseOrders.filter((order) => {
              return order.entity_id == orderId;
            });

            let order = {};
            if (arrayExists.length > 0) {
              order = arrayExists[0];
              order.status = this.$store.state.status[1];
              order.downloaded = true;
            } else {
              order = {
                id: orderId,
                status: this.$store.state.status[1],
                downloaded: false
              };
            }

            this.$store
              .dispatch('updateDownloadedOrder', {
                id: orderId,
                order
              }).then(() => {
                if (updateFirebase) {
                  const status = this.$store.state.status[1];
                  // const realtimeId = this.$store.state.orders[status][orderId].realtimeId;
                  this.changeStatusCall(orderId, status)
                    .then(() => {
                      this.$swal.close();
                    })
                    .catch(() => {
                      this.$swal.close();
                    });
                  /* fdatabase
                    .ref(`Restaurantes/${session.storeId}/Sucursales/${session.storePickUpCode}/Ordenes/${realtimeId}`)
                    .update({
                      Status: status
                    })
                    .then(() => {
                      this.$swal.close();
                    }); */
                }
              });
          } else {
            this.$store
              .dispatch('updateDownloadedOrder', {
                id: orderId,
                order: {
                  id: orderId,
                  status: this.$store.state.status[1],
                  downloaded: false
                }
              })
              .then(() => {
                if (updateFirebase) {
                  const status = this.$store.state.status[1];
                  // const realtimeId = this.$store.state.orders[status][orderId].realtimeId;
                  this.changeStatusCall(orderId, status)
                    .then(() => {
                      this.$swal.close();
                    })
                    .catch(() => {
                      this.$swal.close();
                    });
                  /* fdatabase
                    .ref(`Restaurantes/${session.storeId}/Sucursales/${session.storePickUpCode}/Ordenes/${realtimeId}`)
                    .update({
                      Status: status
                    })
                    .then(() => {
                      this.$swal.close();
                    }); */
                }
              });
          }
        });
      },
      async downloadOrdersCall(ids) {
        const params = {
          ids
        };

        return await this.$magentoAxios.get('newOrders/', params);
      },
    }
  }
</script>

<style scoped>
  .v-tabs {
    height: 88vh;
  }
  .v-tabs--vertical > .v-tabs-bar .v-tab {
    height: 15vh;
  }
  .v-tab {
    max-height: 110px !important;
  }
  .norders-label {
    font-size: 15rem !important;
    width: 480px !important;
    height: 480px !important;
    color: #fff !important;
    margin-bottom: 50px;
  }
  .norders-title {
    font-size: 3rem !important;
    color: #fff !important;
  }
  .norders-text {
    font-size: 1.5rem !important;
    color: #000 !important;
  }
  .margin-left {
    margin-left: 20px;
  }
</style>
